import { IonCol, IonGrid, IonItem, IonRow, IonTextarea } from "@ionic/react";
import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface MyRTFEditorProps {
  handleChange: (value: string, id: string) => void;
  id: string;
  defaultValue?: string;
  readOnly?: boolean;
  seeToolbar: boolean;
  returnHtml: boolean;
}

const RtfEditor: React.FC<MyRTFEditorProps> = ({
  handleChange,
  defaultValue,
  readOnly,
  id,
  returnHtml,
  seeToolbar,
}) => {
  const [editorContent, setEditorContent] = useState<string>("");
  const [modules, setModules] = useState({
    toolbar: seeToolbar,
  });

  useEffect(() => {
    if (defaultValue) {
      setEditorContent(addSpecialCharacters(defaultValue));
    } else {
      setEditorContent("");
    }
  }, [defaultValue]);

  const removeSpecialCharacters = (input: string): string => {
    let textoformateado = input
      .replace(/[\t\r]/g, "")
      .replace(/\n\s+/g, "")
      .replace(/[\n]/g, "</p><p>");

    return textoformateado;
  };

  const addSpecialCharacters = (input: string): string => {
    if (!input || input.trim() === "") {
      return "";
    }

    let textoformateado = input.replace(/[\n]/g, "");

    const indexStartBody = textoformateado.indexOf("<body>");
    const indexEndBody = textoformateado.indexOf("</body>");

    if (indexStartBody !== -1 && indexEndBody !== -1) {
      textoformateado = textoformateado.slice(indexStartBody + 6, indexEndBody);
    }

    textoformateado = textoformateado
      .replace(/<\/p><p>/g, "\n")
      .replace(/<\/p>\s+<p>/g, "\n")
      .replace(/<p>/g, "")
      .replace(/<\/p>/g, "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .trim();

    return textoformateado;
  };

  const handleEditorChange = (
    value: any,
    delta?: any,
    source?: any,
    editor?: any
  ) => {
    setEditorContent(value);
    handleChange(removeSpecialCharacters(value), id);
  };

  return (
    <IonTextarea
      value={editorContent}
      //@ts-ignore
      onKeyUp={(e) => handleEditorChange(e.target.value)}
      fill="outline"
      autoGrow={true}
      style={{ textAlign: "left" }}
    />
  );
};

export default RtfEditor;
